import { html, View } from 'rune-ts';
import klass from './PopularTopNProductSection.module.scss';
import { ProductCardData, ProductCardSize } from '@services/MarppleShop/features/ProductList/type';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle.ts';
import { SeeMoreLinkPlugin } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/plugins';
import { ProductCardList } from '@services/MarppleShop/renderApp/components/cells/ProductCardList/ProductCardList.ts';
import { PostMessageNavigate } from '@services/MarppleShop/shared/app/navigate.ts';

export type PopularTopNProductSectionData = {
  section_title: {
    title: string;
    sub_title: string;
    see_more_link: string;
    navigate: PostMessageNavigate;
  };
  products: ProductCardData[];
};

type PopularTopNProductSectionOption = {
  is_mobile: boolean;
};

export class PopularTopNProductSectionView extends View<PopularTopNProductSectionData> {
  constructor(
    data: PopularTopNProductSectionData,
    private option: PopularTopNProductSectionOption,
  ) {
    super(data, option);
  }

  override template() {
    const { products } = this.data;
    const { is_mobile } = this.option;

    return html`
      <section class="${klass.container}">
        <!-- Section Title -->
        <div class="${klass.title_wrap}">
          ${new SectionTitle({
            title_props: {
              ...this.data.section_title,
              size: is_mobile ? 'large' : 'xLarge',
            },
            plugins: [
              new SeeMoreLinkPlugin({
                navigate: this.data.section_title.navigate,
                see_more_link: this.data.section_title.see_more_link,
                size: is_mobile ? 'xSmall' : 'medium',
                theme: 'light',
              }),
            ],
          })}
        </div>

        ${new ProductCardList(
          { products },
          {
            resize_width: 600,
            container_klass: klass.product_list,
            size: is_mobile ? ProductCardSize.xSmall : ProductCardSize.large,
            is_lazy: true,
            grid: is_mobile
              ? { columns: 3, column_gap: 8, row_gap: 16 }
              : { columns: 5, column_gap: 16, row_gap: 24 },
            limit: is_mobile ? 9 : 10,
          },
        )}
      </section>
    `;
  }
}
